/**
 * Define or change the images
 */


const avatar = require('../assets/img/icons8-user-96.png');
const avatarwhite = require('../assets/img/icons8-user-96 white.png');
const aboutimg = require('../assets/img/imgtest.png');
const userimbl = require('../assets/img/icons8-user-96.png');
const userwhite = require('../assets/img/icons8-user-96 white.png');
const logo = require('../assets/img/Digital insurance Logo.png')
const digital = require('../assets/img/logoTech.png')
//const digital2 = require('../assets/img/Yo')
const backgroundImgalt = require('../assets/img/img-home.jpg');
const Image1 = require('../assets/img/image1.jpeg');
const Image2 = require('../assets/img/vecteezy_concepts-of-risk-management-and-insurance-financial_25075056.jpg');
const Image3 = require('../assets/img/vecteezy_insurance-concept-hand-wooden-arrangement-on-wood-background_18790399.jpg');
const Image4 = require('../assets/img/vecteezy_protection-and-insurance-concept-car-home-and-health_25074876.jpg');
const Image5 = require('../assets/img/vecteezy_portrait-of-young-business-woman-happy-smiling-and-standing_42977817.png');
const Image6 = require('../assets/img/image6.png');
const DisabilityIcon = require('../assets/img/icons8-disability-insurance-96.png');
const DeathIcon = require('../assets/img/icons8-death-insurance-64.png');
const HospitalizationIcon = require('../assets/img/icons8-hospital-insurance-96 (1).png');
const SanlamLogo = require('../assets/img/SANLAMLOGO.png');
const FamPic = require('../assets/img/vecteezy_ai-generated-a-happy-family-of-four-sitting-on-a-comfortable_35474582.jpg');
const ChartPic = require('../assets/img/vecteezy_businessmen-are-talking-about-charts-or-statistics-business_17342611.jpg');
const ManHosp = require('../assets/img/insurance3.JPG');
const ErrorIcon = require('../assets/img/icons8-error-30.png');
const enflag = require('../assets/img/icons8-english-48.png');
const frflag = require('../assets/img/icons8-france-48.png');
const Image9 = require('../assets/img/vecteezy_business-woman-isolated-illustration_24558256.png')
const Client2 = require('../assets/img/WhatsApp Image 2023-12-13 à 11.32.16_7b7db45b.jpg')
const ClientOne = require('../assets/img/ClientOne.jpg')
const Platinium = require('../assets/img/platinuim.webp')
const Gold = require('../assets/img/gold.webp')
const Silver = require('../assets/img/silver.webp')
const Bronze = require('../assets/img/bronze.webp')
const CredixLogo = require ('../assets/img/credixlogo.png')
const ImageHome = require('../assets/img/imageHome.png')
/**
 * export the images object
 */
const Images = {
    avatar,
    avatarwhite,
    Client2,
    aboutimg,
    userimbl,
    userwhite,
    logo,
    digital,
    //digital2,
    backgroundImgalt,
    Image1,
    Image2,
    Image3,
    Image4,
    Image5,
    Image6,
    ImageHome,
    Image9,
    ClientOne,
    DisabilityIcon,
    DeathIcon,
    HospitalizationIcon,
    SanlamLogo,
    FamPic,
    ChartPic,
    ManHosp,
    ErrorIcon,
    enflag,
    frflag,
    Platinium,
    Gold,
    Silver, 
    Bronze,
    CredixLogo


};
export default Images;